@if (authService.isLoggedIn()) {
  <div class="container">
    <mat-toolbar class="row nav nav-container">
      @if (isMaster || isAdmin) {
        <a
          [routerLink]="['/admin/users']"
          [ngClass]="
            isActiveLink('/admin/users') ||
            isActiveLink('/admin') ||
            isUserView()
              ? 'active-link dark-link bold-600 medium-font'
              : 'dark-link bold-600 medium-font'
          "
        >
          {{ translationService.getUsersText() }}
        </a>
      }
      @if (isMaster) {
        <a
          [routerLink]="['/admin/companies']"
          [ngClass]="
            isActiveLink('/admin/companies') || isCompanyView()
              ? 'active-link dark-link bold-600 medium-font'
              : 'dark-link bold-600 medium-font'
          "
        >
          {{ translationService.getCompaniesText() }}
        </a>
      }
      @if (isAdmin || isComplianceOfficer) {
        <a
          [routerLink]="['/admin/integrations']"
          [ngClass]="
            isActiveLink('/admin/integrations')
              ? 'active-link dark-link bold-600 medium-font'
              : 'dark-link bold-600 medium-font'
          "
        >
          {{ translationService.getIntegrationsText() }}
        </a>
        <a
          [routerLink]="['/admin/companies/products']"
          class="dark-link bold-600 medium-font"
          [ngClass]="
            isActiveLink('/admin/companies/products') ||
            isActiveLink('/product-add') ||
            isActiveLink('/import-products') ||
            isActiveLink('/add-to-catalogue') ||
            isActiveLink('/import-product-sharing')
              ? 'active-link dark-link bold-600 medium-font'
              : 'dark-link bold-600 medium-font'
          "
        >
          {{ translationService.getCompanyProductsText() }}
        </a>
      }
      <a
        [routerLink]="['/marketplace']"
        class="dark-link bold-600 medium-font"
        [ngClass]="
          router.url.startsWith('/marketplace')
            ? 'active-link dark-link bold-600 medium-font'
            : 'dark-link bold-600 medium-font'
        "
        >{{ translationService.getMarketplaceBrowseText() }}</a
      >
      @if (isAdmin || isComplianceOfficer) {
        <a
          [routerLink]="['/requisitions']"
          class="dark-link bold-600 medium-font"
          routerLinkActive="active-link"
          ariaCurrentWhenActive="page"
          >{{ translationService.getRequisitionSavedText() }}</a
        >
        <a
          [routerLink]="['/purchase-orders']"
          class="dark-link bold-600 medium-font"
          routerLinkActive="active-link"
          ariaCurrentWhenActive="page"
          >{{ translationService.getPurchaseOrdersText() }}</a
        >
      }
      <a
        [routerLink]="['/ingredients']"
        [ngClass]="
          isIngredientPage()
            ? 'active-link dark-link bold-600 medium-font'
            : 'dark-link bold-600 medium-font'
        "
        >{{ translationService.getIngredientsText() }}</a
      >
      @if (isAdmin || isComplianceOfficer) {
        <a
          [routerLink]="['/admin/reports']"
          [ngClass]="
            isReportsPage()
              ? 'active-link dark-link bold-600 medium-font'
              : 'dark-link bold-600 medium-font'
          "
          >{{ translationService.getReportsText() }}</a
        >
      }
    </mat-toolbar>
  </div>
}
